import { useMutation, useQueryClient } from "react-query";
import { updateFamilyNavigator } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

interface UpdateFamilyNavigatorPayload {
  clientId: string;
  familyNavigatorUserId: string;
}

export const useUpdateFamilyNavigator = (options: any = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading, ...rest } = useMutation(
    (payload: UpdateFamilyNavigatorPayload) => updateFamilyNavigator(payload),
    {
      onSuccess: (response, variables) => {
        queryClient.invalidateQueries(["customer", variables.clientId]);
        showToast({ message: "Family Navigator updated successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to update Family Navigator";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    },
  );

  return {
    updateFamilyNavigator: mutate,
    updateFamilyNavigatorAsync: mutateAsync,
    isUpdatingFamilyNavigator: isLoading,
    ...rest,
  };
};

export default useUpdateFamilyNavigator;
